<!-- ############################################## -->
<!-- ############# Sección de HTML ################ -->
<!-- ############################################## -->
<!-- 
	Definicion de la vista Home, altamente flexible y personalizado,
	construida sobre los cimientos de la mejora progresiva y reactiva,
	agrega caracteristicas de presentacion cuando un usuario es autenticado
 -->
<template>
  <v-content>
    <Home title="FAMISOFT"/>
  </v-content>
</template>


<!-- ############################################## -->
<!-- ############# Seccion de Script ############## -->
<!-- ############################################## -->
<!-- 
	Espacio que permite la configuracion y definicion de propiedades, datos, metodos entre otros, determina 
	el comportamiento de la vista y su ciclo de vida  
 -->
<script>

  /**Definicion de componentes o librerias necesarioas que se complementan con la vista */
  import Home from '@/components/Home'

  /**
    * Definimos el modulo propio de la vista, basado en las directivas de vuejs
    */
	export default {

    /**Objecto que permite registrar los componentes que hacen parte de la vista */
    components: {

      /**Inyectamos el componente Home */
      Home
    }		
	}
</script>


<!-- ############################################## -->
<!-- ############# Sección de CSS ################# -->
<!-- ############################################## -->
<!-- 
	Espacio que permite definir los estilos de la vista
 -->
<style scoped>

  .home-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 3.3rem;
    color: #1CA6B6;
    text-shadow: 1pm 1px 5px #acacac;
  }

  .logo-famisanar {
    max-width: 240px;
  }
  
</style>